import React, {useState} from 'react'
import {useUser} from './context/user-context'
import LoginForm from './LoginForm.js'
import Startpage from './components/Startpage/Startpage.js'
import FullPageSpinner from "./components/FullPageSpinner/FullPageSpinner";

const loadAuthenticatedApp = () => import('./AuthenticatedApp')
const AuthenticatedApp = React.lazy(loadAuthenticatedApp)

function App(props) {
  const { user } = useUser()
  const [hasSeenStartpage, setHasSeenStartpage] = useState(false)
  React.useEffect(() => {
    loadAuthenticatedApp()
  }, [])
  return (
      <React.Suspense fallback={<FullPageSpinner/>}>
        {
          hasSeenStartpage
              ? (user ? <AuthenticatedApp /> : <LoginForm customerName={props.customerName} />)
              : <Startpage user={user} onButtonClick={() => setHasSeenStartpage(true)} />
        }
      </React.Suspense>
  )
}

export default App